import { render, staticRenderFns } from "./SoftwareProducts.vue?vue&type=template&id=0eb0d1e0&scoped=true&"
import script from "./SoftwareProducts.vue?vue&type=script&lang=js&"
export * from "./SoftwareProducts.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareProducts.vue?vue&type=style&index=0&id=0eb0d1e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb0d1e0",
  null
  
)

export default component.exports